// eslint-disable-next-line no-restricted-imports -- decoration only: a missing or failing status must not replace the phase content
import { useQuery } from '@tanstack/react-query';
import { importEndpoints, isNotFoundError } from '@ooh/contracts';
import type { ImportJob } from '@ooh/contracts';
import { useApiClient } from '../../plugs/api-client';
import { apiQueryOptions } from '../../data/use-api-suspense-query';

interface JobStatusLookup {
  job: ImportJob | undefined;
  notFound: boolean;
}

/**
 * Looks the job up for chrome that only decorates the screen (stepper layout, source bar
 * file name). It shares the status cache entry with the phases, so it adds no requests of its own.
 * Skips the request for `undefined`. `notFound` is true only when the server says the job does not exist.
 */
export function useJobStatusLookup(importJobId: number | undefined): JobStatusLookup {
  const api = useApiClient();
  const id = importJobId ?? 0;
  const { data, error } = useQuery({
    ...apiQueryOptions(api, importEndpoints.getStatus, { id }),
    enabled: id > 0,
  });
  return { job: data, notFound: error != null && isNotFoundError(error) };
}

export function useOptionalJobStatus(importJobId: number | undefined): ImportJob | undefined {
  return useJobStatusLookup(importJobId).job;
}
